import { render, staticRenderFns } from "./guardian-group-item.vue?vue&type=template&id=3f199456"
import script from "./guardian-group-item.ts?vue&type=script&lang=js&external"
export * from "./guardian-group-item.ts?vue&type=script&lang=js&external"
import style0 from "./guardian-group-item.vue?vue&type=style&index=0&id=3f199456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports